import sound from './move.wav';export default sound;